import {userConstants} from '../constants/user.constants'

const user=null
const initialState=user? {loggedIn:true,isLoading:false,user }:{}

export function generateManualPaymentsReceipt(state = initialState, action) {
  switch (action.type) {
    case userConstants.POST_GENERATE_RECEIPT_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.POST_GENERATE_RECEIPT_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.POST_GENERATE_RECEIPT_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}